import Im from "immutable";
import React, { useState } from "react";
import Octicon from "react-octicon";

import { ErrorBoundary } from "storybook-dashboard/errors";
import { confirmDelete } from "traec-react/utils/sweetalert";
import { TableRow } from "./tableRow";
import { TableHeaders } from "./headers";
import { HeaderButtons, SaveButton } from "./headerButtons";
import { validateFields } from "./validateFields";

export const DataTable = (props) => {
  let { fields, formName, data, setData, readOnly, setDirty } = props;
  const [tableVisible, setTableVisible] = useState(false);

  let filename = `${formName}.csv`;
  let allErrors = Im.List();

  let rows = data.map((d, i) => {
    const errors = validateFields(fields, d);
    allErrors = allErrors.concat(errors);
    return (
      <TableRow
        key={i}
        index={i}
        fields={fields}
        data={d}
        setData={setData}
        readOnly={readOnly}
        errors={errors}
        removeHandler={(e) => {
          confirmDelete({
            text: `Are you sure you want to remove this row?`,
            onConfirm: () => {
              setData(data.delete(i));
              setDirty(true);
            },
          });
        }}
        updateHandler={(rowData) => {
          setData(data.set(i, rowData));
          setDirty(true);
        }}
        copyHandler={(rowData) => {
          setData(data.insert(i, rowData));
          setDirty(true);
        }}
      />
    );
  });

  return (
    <ErrorBoundary>
      <HeaderButtons {...props} filename={filename} setTableVisible={setTableVisible} />
      <div style={{ clear: "both" }} />

      {tableVisible && (
        <>
          <div className="horizontal-scrollbar mb-1 py-1" style={{ overflowX: "scroll" }}>
            <table width="100%" className="table table-sm scrollTopContent m-0 p-0">
              <thead>
                <TableHeaders fields={fields} readOnly={readOnly} />
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>
          <div className="float-right">
            <button
              onClick={() => {
                //const emptyObject = fields.map((f) => f.get("header")).reduce((a, v) => a.set(v, null), Im.Map());
                //setData(data.push(emptyObject));
                setData(data.push(Im.Map()));
              }}
              style={{ cursor: "pointer" }}
              className="btn btn-success btn-sm mr-1 text-white text-nowrap"
              disabled={readOnly}
            >
              <Octicon name="plus" /> Add
            </button>
            <SaveButton {...props} filename={filename} errors={allErrors} />
          </div>
        </>
      )}
    </ErrorBoundary>
  );
};
